function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    var items = location.search.substr(1).split("&");
    for (var index = 0; index < items.length; index++) {
        tmp = items[index].split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    }
    return result;
}

function getGTMParameters(gtmProduct, pageContext) {
    var gtmParams = gtmProduct.querySelector('.gtm-params');
    
    if (!gtmParams) {
        console.warn('gtm-params not found in:', gtmProduct);
        return null;
    }
    
    var productCurrencyCode = gtmParams.getAttribute('data-gtm-currencycode');
    var productList = '';
    
    if (pageContext) {
        if (pageContext.ns == 'homepage') {
            productList = 'homepage';
        }
        else if (pageContext.ns == 'search' && findGetParameter('q') != null) {
            productList = 'q='+findGetParameter('q');
        }
        else {
            var breadcrumb = document.querySelector('.cc-breadcrumb__wrp');
            if (breadcrumb) {
                productList = breadcrumb.textContent.replace(/\n/g, "").replace(/ /g, "");
            }
        }
    }
    
    return {
        'name': gtmParams.getAttribute('data-gtm-productname'),
        'id': gtmParams.getAttribute('data-gtm-productid'),
        'price': gtmParams.getAttribute('data-gtm-productprice'),
        'sv8': gtmParams.getAttribute('data-gtm-productstartprice'),
        'brand': gtmParams.getAttribute('data-gtm-productbrand'),
        'category': gtmParams.getAttribute('data-gtm-productcategory'),
        'categoryid': gtmParams.getAttribute('data-gtm-productcategoryid'),
        'item_sku': gtmParams.getAttribute('data-gtm-itemsku'),
        'item_sku_variation': gtmParams.getAttribute('data-gtm-itemskuvariation'),
        'item_category': gtmParams.getAttribute('data-gtm-itemcategory'),
        'item_category2': gtmParams.getAttribute('data-gtm-itemcategory2'),
        'item_category3': gtmParams.getAttribute('data-gtm-itemcategory3'),
        'item_category4': gtmParams.getAttribute('data-gtm-itemcategory4'),
        'list': productList,
        'position': 1,
        'productCurrencyCode': productCurrencyCode
    }
}

function sendClickGTM(event) {
    if(typeof dataLayer !== 'undefined' && window.analyticsWrapper) {
        var gtmProduct = event.currentTarget.querySelector('.gtm-product-parms');
        var pageContext = window.pageContext;
        var params = getGTMParameters(gtmProduct, pageContext);

        try{
            window.analyticsWrapper('productClick', {
                'ecommerce': {
                    'currencyCode': params.productCurrencyCode,
                    'click': {
                        'actionField': {'list': params.list},
                        'products': [{
                            'name': params.name,
                            'id': params.id,
                            'price': params.price,
                            'sv8': params.sv8,
                            'brand': params.brand,
                            'category': params.category,
                            'categoryid': params.categoryid,
                            'position': params.position,
                            'item_sku': params.item_sku,
                            'item_sku_variation': params.item_sku_variation,
                            'item_category': params.item_category,
                            'item_category2': params.item_category2,
                            'item_category3': params.item_category3,
                            'item_category4': params.item_category4
                        }]
                    }
                }
            }, 'true', 'it');
        }
        catch(error){
            console.error('Error: impossible to send event productClick');
        }
    }
}

window.initGTMProductTileImpressions = function () {
    
    if(typeof dataLayer !== 'undefined' && window.analyticsWrapper) {
        var gtmProducts = document.querySelectorAll('.gtm-product-parms');
        if (!gtmProducts.length) return;
        
        var productImpressions = [];
        var currencyCode = '';
        var pageContext = window.pageContext;

        gtmProducts.forEach(function (gtmProduct) {
            if (!gtmProduct.classList.contains('gtm-impressed')) {
                var params = getGTMParameters(gtmProduct, pageContext);
                
                if (!params) return; // Skip if params extraction failed
                
                productImpressions.push({
                    'name': params.name, // Nome prodotto
                    'id': params.id, //SKU o ID completo del prodotto
                    'price': params.price, //Prezzo di vendita del prodotto
                    'sv8': params.sv8, //Prezzo iniziale di vendita del prodotto senza sconto
                    'brand': params.brand, //Brand del prodotto
                    'category': params.category, // Nome categoria/tipologia associata al prodotto
                    'categoryid': params.categoryid, // ID categoria/tipologia associata al prodotto
                    'list': params.list, // Tipologia di lista in cui l’utente vede il prodotto è necessaria per il tracciamento in GA
                    'position': params.position, //è necessaria per il tracciamento in GA
                    'item_sku': params.item_sku,
                    'item_sku_variation': params.item_sku_variation,
                    'item_category': params.item_category,
                    'item_category2': params.item_category2,
                    'item_category3': params.item_category3,
                    'item_category4': params.item_category4
                })

                gtmProduct.classList.add('gtm-impressed');
                
                if (currencyCode != params.productCurrencyCode) {
                    currencyCode = params.productCurrencyCode;
                }
            }
        });

        try{
            window.analyticsWrapper('productImpression', {
                'ecommerce': {
                    'currencyCode': currencyCode, // Valuta locale
                    'impressions': productImpressions
                }
            });
        }
        catch(error){
            console.error('Error: impossible to send event productImpression');
        }
    }

}

window.initGTMProductTileClicks = function () {
    var productTiles = document.querySelectorAll('.product');
    
    productTiles.forEach(function (productTile) {
        var dataItemElement = productTile.querySelector('.data-itemid');
        if (dataItemElement && dataItemElement.getAttribute('data-itemid') && !productTile.classList.contains('gtm-clicked')) {
            productTile.addEventListener('click', sendClickGTM);
            productTile.classList.add('gtm-clicked');
        }
    });
}

// Vanilla JS DOM ready - no jQuery dependency
document.addEventListener('DOMContentLoaded', function() {
    // ProducTiles impression
    window.initGTMProductTileImpressions();
    
    // ProducTiles click
    window.initGTMProductTileClicks();
});